import axios from "axios";
import { renderPage, renderArticles } from "../helpers/renderTemplate";
import { pagePropertyListener } from "../helpers/propertyListener";
import { paginationListener } from "../helpers/pagination";
import { linkGroupHandler } from "../helpers/fixedLink";

const apiData = { ...DHHU_vars };
let scrollAnim = null;

// 頁數監聽資料
const paginationData = {
  _currentPage: 1,
  max_page: 9999,
  type: "normal",
  isInit: true,
};

// api 夾帶資料
const apiOutputData = {
  data: {
    taxonomy: "production_catalog",
    terms: "terms",
  },
};
const loadingCanvas = document.querySelector(`[data-id="loading-canvas"]`); // loading 畫面
productionInit();
/**
 * 初始化設定
 */
function productionInit() {
  apiOutputData.data.taxonomy = apiData.taxonomy;
  apiOutputData.data.terms = apiData.terms;

  if (apiOutputData.data.taxonomy == "production") {
    getContentApi(1);
  } else {
    paginationData.type = "terms";
    getTermsContentApi(1, apiOutputData, paginationData.isInit);
  }
  termsBtnListener();
  accordionHandler();
  pagePropertyListener(paginationData, changePage);
}

/**
 * 非同步取得產品介紹文章資料
 * @param {頁數} page
 * @param {是否為初次渲染} isInit
 */
async function getContentApi(page, isInit = true) {
  const jsonNonce = apiData.nonce; // 隨機碼
  const eventUrl = apiData.site_url; // 網站前方 url
  const eventAll = `${eventUrl}/wp-json/wp/v1/${apiData.type}_${jsonNonce}/${page}`;
  loadingCanvas.classList.remove("opacity-0");

  try {
    const response = await axios.get(eventAll);
    const jsonData = response.data.data;
    paginationData.max_page = response.data.maxPage;

    loadingCanvas.classList.add("opacity-0");
    renderArticles(jsonData, {
      imgHeight: 282,
      changePageType: "changePage",
      contentType: "production",
    });

    // 渲染頁數
    renderPage(paginationData.max_page, paginationData.currentPage);

    // 建立分頁監聽
    paginationListener(paginationData);
    if (scrollAnim) {
      scrollAnim.kill();
    }
    scrollAnim = linkGroupHandler();
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

/**
 * 非同步取得產品介紹資料 (依類別分類)
 * @param {頁數} page
 * @param {資料} data
 * @param {是否為初次渲染} isInit
 */
async function getTermsContentApi(page, data, isInit = true) {
  const jsonNonce = apiData.nonce; // 隨機碼
  const eventUrl = apiData.site_url; // 網站前方 url
  const eventTerms = `${eventUrl}/wp-json/wp/v1/productionClassification_${jsonNonce}`;
  const eventAll = `${eventUrl}/wp-json/wp/v1/${apiData.type}_${jsonNonce}/${page}`;
  loadingCanvas.classList.remove("opacity-0");
  try {
    const responseTerms = await axios.post(eventTerms, data); // 類別介紹資料
    const responseAll = await axios.post(eventAll, data);

    const jsonData_terms = responseTerms.data.data;
    const jsonData_all = responseAll.data.data;
    paginationData.max_page = responseAll.data.maxPage;

    loadingCanvas.classList.add("opacity-0");
    // renderContent(jsonData_all);
    renderArticles(jsonData_all, {
      imgHeight: 282,
      changePageType: "changePage",
      contentType: "production",
    });
    renderTermsContent(jsonData_terms);

    // 渲染頁數
    renderPage(paginationData.max_page, paginationData.currentPage);
    // 建立分頁監聽
    paginationListener(paginationData);
    if (scrollAnim) {
      scrollAnim.kill();
    }
    scrollAnim = linkGroupHandler();
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

/**
 * 渲染產品介紹文章資料
 * @param {文章資料} data
 */
// function renderContent(data) {
//   let output = "";
//   const productionPostContainer = document.querySelector(
//     `[data-id="content-container"]`
//   );
//   data.forEach((item) => {
//     output += `<li class="col-span-4 flex flex-col gap-3 items-center group pointer-events-auto cursor-pointer relative">
//       <div class="w-full h-auto aspect-square overflow-hidden">
//         <img class="group-hover:scale-[1.15] duration-500 transition-all object-cover w-full h-full" src="${item.photo}"/>
//       </div>
//       <h4 class="text-lg leading-tight tracking-2 font-medium">${item.title}</h4>
//       <p class="text-sm leading-normal text-gray-4">#${item.production_catalog}</p>
//       <a href="${item.link}" class="stretched-link"></a>
//     </li>`;
//   });

//   productionPostContainer.innerHTML = output;
// }

/**
 * 更換目前頁數
 */
function changePage() {
  const parentElement = document.querySelector(
    `[data-id="product_classification_container"]`
  );
  const targetPixelValue = parentElement.offsetTop;
  window.scrollTo({
    top: targetPixelValue,
    behavior: "smooth",
  });

  // 型態為一般切換
  if (paginationData.type == "normal") {
    getContentApi(paginationData.currentPage, false);
  } else {
    // 型態為類別切換
    getTermsContentApi(
      paginationData.currentPage,
      apiOutputData,
      paginationData.isInit
    );
  }
}

/**
 * 手風琴折疊清單樣式切換管理
 */
function accordionHandler() {
  // 取得當前網址
  const currentUrl = window.location.href;
  const urlArr = currentUrl.split("/").filter((item) => item !== "");
  const terms = urlArr[urlArr.length - 1];
  const accordionBtnGroup = document.querySelectorAll(
    `[data-type="accordion"]`
  );

  if (terms === apiData.terms) {
    const openContent = document.querySelector(
      `[data-id="${apiData.termsParent}-content"]`
    );
    const openBtn = document.querySelector(
      `[data-id="${apiData.termsParent}-btn"]`
    );

    const svgClose = openBtn.children[0];
    const svgOpen = openBtn.children[1];
    svgClose.classList.add("opacity-0");
    svgOpen.classList.remove("opacity-0");

    openContent.classList.remove("grid-rows-0");
    openContent.classList.add("grid-rows-1");
  }

  let lastList = null;

  accordionBtnGroup.forEach((parent) => {
    parent.addEventListener("click", (e) => {
      const accordionBtn = parent.children[0];
      const accordionList = parent.children[1];

      const svgClose = accordionBtn.children[0];
      const svgOpen = accordionBtn.children[1];

      // 關閉上次開啟的摺疊清單
      if (lastList !== null && lastList.accordionList !== accordionList) {
        lastList.svgClose.classList.remove("opacity-0");
        lastList.svgOpen.classList.add("opacity-0");
        lastList.accordionList.classList.remove("grid-rows-1");
        lastList.accordionList.classList.add("grid-rows-0");
      }

      lastList = {
        accordionList,
        svgClose,
        svgOpen,
      };

      // 摺疊清單收合
      if (e.target.dataset.type === "accordion-btn") {
        if (accordionList.classList.contains("grid-rows-0")) {
          svgClose.classList.add("opacity-0");
          svgOpen.classList.remove("opacity-0");
          accordionList.classList.remove("grid-rows-0");
          accordionList.classList.add("grid-rows-1");
        } else {
          svgOpen.classList.add("opacity-0");
          svgClose.classList.remove("opacity-0");
          accordionList.classList.add("grid-rows-0");
          accordionList.classList.remove("grid-rows-1");
        }
      }
    });
  });
}

/**
 * 類別按鈕監聽
 */
function termsBtnListener() {
  const termsBtnGroup = document.querySelectorAll(`[data-type="terms_btn"]`);

  termsBtnGroup.forEach((btn) => {
    btn.addEventListener("click", () => {
      const terms_slug = btn.dataset.id;
      // 資料處理
      apiOutputData.data.terms = terms_slug;

      // 頁數切換
      window.location = `${apiData.site_url}/production_catalog/${terms_slug}/`;
    });
  });
}

/**
 * 渲染產品介紹文章資料
 * @param {文章資料} data
 * @returns 未獲取資料直接跳出
 */
function renderTermsContent(data) {
  const productClassification = data.product_classification;

  const productClassificationContainer = document.querySelector(
    `[data-id="product_classification_container"]`
  );
  let output = "";
  output = `
  <div class="grid grid-cols-9 gap-6 mb-[50px]">
    <div class="col-span-12 md:col-span-6 lg:col-span-4">
      <img class="w-full h-auto object-cover aspect-square" src="${
        productClassification?.img?.url
      }"/>
    </div>
    <div class="col-span-12 lg:col-span-5">
      <div class="flex flex-col justify-center  gap-6 h-full">
        <h2 class="text-2xl leading-tight tracking-2 sm:text-[32px] sm:leading-tight">${
          productClassification?.title
        }</h2>
        <p class="text-sm leading-normal sm:text-base">${
          productClassification?.introduction
        }</p>
        <ul class="grid-cols-1 gap-6 sm:grid-cols-3  hidden sm:gap-3 md:grid">
          ${
            !productClassification.features
              ? ""
              : productClassification?.features
                  .map(
                    (
                      item
                    ) => `<li class="col-span-1 flex flex-col items-center gap-2">
            <img class="rounded-full w-[100px] h-auto aspect-square object-cover" src="${item?.img?.url}" alt="${item?.title}" />
            <p class="text-sm leading-normal sm:text-base">${item?.title}</p>
            <p class="text-xs leading-tight text-center">${item?.content}</p>
          </li>`
                  )
                  .join("")
          }
        </ul>
      </div>
    </div>
  </div>`;

  productClassificationContainer.innerHTML = output;
}
productionSidebarHandler();

function productionSidebarHandler() {
  const productionSidebarBtn = document.querySelector(
    `[data-id="productionSidebar-btn"]`
  );
  const productionSidebarContent = document.querySelector(
    `[data-id="productionSidebar-content"]`
  );
  const productionSidebarCloseBtn = document.querySelector(
    `[data-id="productionSidebar-closeBtn"]`
  );
  const body = document.querySelector("body");
  if (productionSidebarBtn) {
    productionSidebarBtn.addEventListener("click", () => {
      productionSidebarBtn.classList.add("-translate-x-full");
      productionSidebarContent.classList.remove("-translate-x-full");
      body.classList.add("h-dvh", "overflow-hidden");
    });
  }
  productionSidebarCloseBtn.addEventListener("click", () => {
    productionSidebarContent.classList.add("-translate-x-full");
    productionSidebarBtn.classList.remove("-translate-x-full");
    body.classList.remove("h-dvh", "overflow-hidden");
  });
}
